import React, { useState, useEffect } from 'react'
import { Fragment } from 'react'
import { Row, Col, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input } from 'reactstrap'
import { Breadcrumbs, Btn, H4 } from '../../AbstractElements'
import { getIdData, addData, updateData } from '../../lib/class'
import { ClassForLessonSelect, InstructorSelect, SubInstructorSelect } from '../Common/FormSelects'
import { useNavigate, useParams } from 'react-router-dom'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const ClassCreate = () => {
	const [classname, setClassName] = useState('')
	const [isActive, setIsActive] = useState(true)
	const [selectedInstructor, setSelectedInstructor] = useState('')
	const [selectedSubInstructor, setSelectedSubInstructor] = useState('aaa')
	const [selectedGrade, setSelectedGrade] = useState(9)
	const [loading, setLoading] = useState(false)
	const navigate = useNavigate()
	const layout = useLayout()
	let { id } = useParams()
	const role = useRoleBasedUrl()

	const isEditMode = id && id !== 'create'

	async function GetData(classId) {
		try {
			setLoading(true)
			const classData = await getIdData(classId)

			if (classData && classData.length > 0) {
				setClassName(classData[0].class_name)
				setIsActive(classData[0].isActive)
				setSelectedGrade(classData[0].grade)
				setSelectedInstructor(classData[0].instructorId)
				setSelectedSubInstructor(classData[0].subinstructorId || 'aaa')
			}
		} catch (error) {
			console.error('Error fetching class data:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			const classData = {
				class_name: classname,
				instructorId: selectedInstructor,
				grade: selectedGrade,
				isActive: isActive,
				subinstructorId: selectedSubInstructor === 'aaa' ? null : selectedSubInstructor
			}

			if (isEditMode) {
				await updateData({
					id: id,
					...classData
				})
			} else {
				await addData(classData)
			}

			navigate(`${process.env.PUBLIC_URL}/${role}/class-management/${layout}`)
		} catch (error) {
			console.error('Error saving class:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (isEditMode) {
			GetData(id)
		}
	}, [id, isEditMode])

	return (
		<Fragment>
			<Breadcrumbs
				mainTitle={isEditMode ? 'Edit Class' : 'Create Class'}
				parent="Class Management"
				title={isEditMode ? 'Edit Class' : 'Create Class'}
			/>
			<Form className="card" onSubmit={handleSubmit}>
				<CardHeader>
					<H4 attrH4={{ className: 'card-title mb-0' }}>{isEditMode ? 'Edit Class' : 'Create New Class'}</H4>
					<div className="card-options">
						<a className="card-options-collapse" href="#javascript">
							<i className="fe fe-chevron-up"></i>
						</a>
						<a className="card-options-remove" href="#javascript">
							<i className="fe fe-x"></i>
						</a>
					</div>
				</CardHeader>
				<CardBody>
					<Row>
						<Col md="8">
							<FormGroup>
								<Label className="form-label">Class Name</Label>
								<Input
									type="text"
									value={classname}
									onChange={(e) => setClassName(e.target.value)}
									className="form-control"
									placeholder="Enter Class Name"
									required
								/>
							</FormGroup>
						</Col>
						<Col md="8">
							<FormGroup>
								<ClassForLessonSelect value={selectedGrade} setValue={setSelectedGrade} />
							</FormGroup>
						</Col>
						<Col md="8">
							<FormGroup>
								<InstructorSelect value={selectedInstructor} setValue={setSelectedInstructor} />
							</FormGroup>
						</Col>
						<Col md="8">
							<FormGroup>
								<SubInstructorSelect value={selectedSubInstructor} setValue={setSelectedSubInstructor} excludeInstructor={selectedInstructor} />
							</FormGroup>
						</Col>
						<Col md="8">
							<FormGroup>
								<Label className="form-label">Is Active</Label>
								<div className="form-check form-switch">
									<Input className="form-check-input" type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
									<Label className="form-check-label">{isActive ? 'Active' : 'Inactive'}</Label>
								</div>
							</FormGroup>
						</Col>
					</Row>
				</CardBody>
				<CardFooter className="text-end">
					<Btn attrBtn={{ color: 'primary', type: 'submit', className: 'me-2', disabled: loading }}>
						{loading ? 'Saving...' : isEditMode ? 'Update Class' : 'Create Class'}
					</Btn>
					<Btn attrBtn={{ color: 'secondary', className: 'me-2', onClick: () => navigate(-1) }}>Cancel</Btn>
				</CardFooter>
			</Form>
		</Fragment>
	)
}

export { ClassCreate }
